<!-- Single Select -->
<p-dropdown *ngIf="show && (to.mode === 'default' || !to.mode)"
            [options]="to.options"
            [optionLabel]="'label'"
            [optionValue]="to.modelId ? null : 'value'"
            [formControl]="formControl"
            [autoDisplayFirst]="false"
            [showClear]="true"
            [required]="to.required"
            [compareWith]="compareWith"
            (onChange)="selectChange($event)">
</p-dropdown>

<!-- Multi Select -->
<p-multiSelect *ngIf="show && to.mode === 'multiple'"
               [options]="to.options"
               [optionLabel]="'label'"
               [optionValue]="to.modelId ? null : 'value'"
               [formControl]="formControl"
               [showClear]="true"
               [required]="to.required"
               (onChange)="selectChange($event)">
</p-multiSelect>
